import { render } from "./FinalDates.vue?vue&type=template&id=43365034"
import script from "./FinalDates.vue?vue&type=script&lang=ts"
export * from "./FinalDates.vue?vue&type=script&lang=ts"

import "./FinalDates.vue?vue&type=style&index=0&id=43365034&lang=scss"
script.render = render

export default script